import Vue from 'vue';
import Unlicensed from "./Unlicensed.vue";

new Vue({
    el: '#unlicensed',
    render: (h) => h(Unlicensed)
});
